import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { PasswordSessionService } from './password-session.service';
import { ChallengeStorageService } from './challenge-storage.service';
import { ApiService } from './api.service';
import {
    ChallengeBaseResponseDto,
    ChallengeDeviceVerifyRequestDto,
    ChallengeChangePasswordRequestDto,
    ChallengeInitMfaRequestDto,
    ChallengeInitMfaResponseDto,
    ChallengeVerifyOtpRequestDto,
    ChallengeChangeMfaRequestDto,
} from '@qc/shared/dto';

@Injectable({ providedIn: 'root' })
export class AuthChallengeService extends ApiService {
    private readonly passwordSessions = inject(PasswordSessionService);
    private readonly challenges = inject(ChallengeStorageService);

    protected get basePath(): string {
        return '/auth/challenge';
    }

    initMfaMethod(request: ChallengeInitMfaRequestDto) {
        return this.post<ChallengeInitMfaResponseDto>('init-mfa', request);
    }

    verifyOtp(request: ChallengeVerifyOtpRequestDto) {
        return this.post<ChallengeBaseResponseDto>('verify-otp', request);
    }

    resendOtp() {
        return this.post<ChallengeBaseResponseDto>('resend-otp');
    }

    changeMfa(request: ChallengeChangeMfaRequestDto) {
        return this.post<ChallengeBaseResponseDto>('change-mfa', request);
    }

    verifyDevice(request: ChallengeDeviceVerifyRequestDto) {
        return this.post<ChallengeBaseResponseDto>('verify-device', request);
    }

    changePassword(request: ChallengeChangePasswordRequestDto) {
        const identity = this.passwordSessions.identity(this.challenges.getAuthChallengeToken());
        return this.post<ChallengeBaseResponseDto>('change-password', request).pipe(
            // Keep this tab's reset/MFA challenge alive while logging out its other sessions.
            tap(() => this.passwordSessions.passwordChanged(identity, false)),
        );
    }
}
